export default "__VITE_ASSET__C5oFhmUp__"